import firebase from "firebase/app";
import "firebase/firestore"

var firebaseConfig = {
    apiKey: "AIzaSyAUMJftaXU6ZJ0yJevhO_FfQYrTxZUhcog",
    authDomain: "midmichigan-ag.firebaseapp.com",
    projectId: "midmichigan-ag",
    storageBucket: "midmichigan-ag.appspot.com",
    messagingSenderId: "345349561279",
    appId: "1:345349561279:web:6b47e8a9d3e81e0333df0a"
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

export { db };
